import React, { useEffect, useState } from "react";
import { Typography, Grid, Table, TableRow, TableCell } from "@mui/material";
import { Divider } from "@mantine/core";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import "./ProductDetailsPrimary.css";
import { ReactComponent as FreeProductSvg } from "../../assets/image/svg/freeProduct.svg"
import { showUom, truncateToTwoDecimals } from "../dms_common/DmsUtils";
import { getRemovedFields } from "./util";

interface ProductDetailProps {
  product: Record<string, any>;
}

const ProductDetailsPrimary = ({ product }: ProductDetailProps) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    caseUnitLabelPrimary,
    otherUnitLabelPrimary,
    packUnitLabelPrimary,
    currency,
    createPrimaryOrderUom,
  } = ConfigDictionary;



  const [columns, setColumns] = useState<any[]>([]);

  useEffect(() => {
    const fetchTableMetadata = async () => {
      const removedFields = await getRemovedFields();
      const initialColumns = [
        { headerName: "Total Amt", field: "initialAmount", type: "number" },
        { headerName: "Discount Value", field: "discountValue", type: "number" },
        { headerName: "Final Amt", field: "netAmount", type: "number" },
      ];

      const filteredColumns = initialColumns.filter(
        (col) => !removedFields.includes(col.field)
      );
      setColumns(filteredColumns);
    };

    fetchTableMetadata();
  }, []);

  return (
    <div className="product_details_container">
      <Grid container spacing={2} justifyContent={"space-between"}>
        <Grid item xs={5}>
          <div style={{ display: "flex" }}>
            {product?.initialNormalizedQuantity === 0 && (
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "29px",
                  height: "29px",
                }}
              >
                <FreeProductSvg style={{ width: "100%", height: "auto" }} />
                <span
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "7px",
                    fontWeight: 600,
                    color: "#fff",
                    pointerEvents: "none",
                  }}
                >
                  FREE
                </span>
              </div>
            )}
            <Typography
              sx={{ fontWeight: "600", fontSize: "13px", color: "#202020", paddingLeft: "5px" }}
            >
              {product?.skuDescription || ""}
            </Typography>
          </div>
          {product?.discountInfo?.map((scheme: any) => {
            if (scheme?.id === "focDiscountId") {
              return <></>
            }
            return (
              <div className="product_scheme_container">
                <LocalOfferIcon sx={{ color: "#24c6b1", fontSize: "13px", marginTop: "5px" }} />
                <div className="scheme_container">
                  <Typography sx={{ fontSize: "10px", color: "#166ae7", fontWeight: 600 }}>
                    {["ilc", "coupon"].includes(scheme?.programLevel?.toLowerCase()) ? "Coupon" : "Scheme"}: 
                  </Typography>
                  <Typography sx={{ fontSize: "10px", color: "#166ae7", fontWeight: 500, lineHeight: "1.3" }}>
                    {scheme?.discountInfo ?? ""}
                  </Typography>
                </div>
              </div>
            );
          })}
        </Grid>
        <Grid item xs={6} sx={{ alignItems: "flex-end", paddingLeft: "0px !important" }}>
          <Table className="product_detail_table">
            <TableRow>
              {caseUnitLabelPrimary && showUom("caseQty", createPrimaryOrderUom) && (
                <>
              <TableCell className="black_shade_1">Unit</TableCell>
              <TableCell className="black_shade_1">Qty</TableCell>
              </>
              )}
              {otherUnitLabelPrimary && showUom("otherQty", createPrimaryOrderUom) && (
                <>
                  <TableCell className="black_shade_1">Unit</TableCell>
                  <TableCell className="black_shade_1">Qty</TableCell>
                </>
              )}
              {packUnitLabelPrimary && showUom("pieceQty", createPrimaryOrderUom) && (
                <>
              <TableCell className="black_shade_1">Unit</TableCell>
              <TableCell className="black_shade_1">Qty</TableCell>
              </>
              )}
            </TableRow>
            <TableRow className="product_value_table_cell">
              {caseUnitLabelPrimary && showUom("caseQty", createPrimaryOrderUom) && (
                  <>  
              <TableCell className="black_shade_2">{caseUnitLabelPrimary}</TableCell>
              <TableCell className="black_shade_2">{product?.caseQuantity}</TableCell>
              </>
              )}
              {otherUnitLabelPrimary && showUom("otherQty", createPrimaryOrderUom) && (
                <>
                  <TableCell className="black_shade_2">{otherUnitLabelPrimary}</TableCell>
                  <TableCell className="black_shade_2">{product?.otherUnitQuantity}</TableCell>
                </>
              )}
              {packUnitLabelPrimary && showUom("pieceQty", createPrimaryOrderUom) && (
                <>
              <TableCell className="black_shade_2">{packUnitLabelPrimary}</TableCell>
              <TableCell className="black_shade_2">{product?.pieceQuantity}</TableCell>
              </>
            )}
            </TableRow>
          </Table>
          <Grid container sx={{ marginTop: "6px" }}>
            <Grid item xs={12} sx={{ background: "#F0F0F1", padding: "6px" }}>
              <Table className="final_product_detail_table">
                <TableRow>
                  {
                    columns.map((col: any) => (
                      <TableCell className="black_shade_1" key={col.field}>{col.headerName}</TableCell>
                    ))
                  }
                </TableRow>
                <TableRow className="product_value_table_cell">
                  {
                    columns.map((col: any) => (
                      <TableCell className="black_shade_2" key={col.field}>
                        {currency}
                        {truncateToTwoDecimals(product?.[col.field] || 0)}
                      </TableCell>
                    ))
                  }
                </TableRow>
              </Table>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider
        sx={{ height: "14px", marginTop: "10px" }}
        color="#f1f1f1"
        variant="dotted"
        size="sm"
      />
    </div>
  );
};

export default ProductDetailsPrimary;
